angular.module('st')
    .directive("convertToNumber", function () {
        return {
            require: "ngModel",
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (val) {
                    return val != null ? parseInt(val, 10) : null;
                });
                ngModel.$formatters.push(function (val) {
                    return val != null ? "" + val : null;
                });
            }
        };
    });

angular.module('st')
    .factory("messageListFactory", function () {
        const IsNullOrEmpty = function (str) {
            return str === undefined || str === null || str === "";
        };
        const messageList = function () {
            let msgs = {};

            const clearMessages = function () {
                msgs = {};
            };
            const setMessage = function (key, msg) {
                msgs[key] = msg;
            };
            const hasMessage = function (key) {
                if (key) {
                    return !IsNullOrEmpty(msgs[key]);
                }
                else {
                    let msgFound = false;
                    for (var prop in msgs) {
                        if (msgs.hasOwnProperty(prop)) {
                            if (!IsNullOrEmpty(msgs[prop])) {
                                msgFound = true;
                                break;
                            }
                        }
                    }
                    return msgFound;
                }
            };
            const getMessages = function (key) {
                
                if (key) return msgs[key];
                else {
                    let msgArray = [];
                    for (let prop in msgs) {
                        if (msgs.hasOwnProperty(prop)) {
                            if (!IsNullOrEmpty(msgs[prop])) {
                                msgArray.push(msgs[prop]);
                            }
                        }
                    }
                    return msgArray;
                }
            };
            const loadMessages = function (dict) {
                if (dict) {
                    for (let i = 0; i < dict.length; i++) {
                        msgs[dict[i].Key] = dict[i].Message;
                    }
                }
            };
            return {
                clear: clearMessages,
                set: setMessage,
                has: hasMessage,
                get: getMessages,
                load: loadMessages
            };
        };

        return {
            createList: function () {
                return messageList();
            }
        };
    });

